import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AIAgentDefinitions } from "@graylog/enterprise-api";
import { WORKFLOW_DEFINITIONS_QUERY_KEY } from "../Constants";
const updateWorkflowConfig = async ({
  workflow,
  config
}) => (
  // The config is a polymorphic AgentConfig identified solely by its `type` discriminator, which
  // matches the workflow id.
  AIAgentDefinitions.updateConfig({ type: workflow.id, ...config })
);
const useUpdateWorkflowConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateWorkflowConfig,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: WORKFLOW_DEFINITIONS_QUERY_KEY })
  });
};
export default useUpdateWorkflowConfig;
